import { render, staticRenderFns } from "./UserPrivacy.vue?vue&type=template&id=63a65362&scoped=true&"
import script from "./UserPrivacy.vue?vue&type=script&lang=ts&"
export * from "./UserPrivacy.vue?vue&type=script&lang=ts&"
import style0 from "./UserPrivacy.vue?vue&type=style&index=0&id=63a65362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a65362",
  null
  
)

export default component.exports